// Browser-Wiring der A/V-Sync-Korrektur. Reine Mathematik in av-sync-offset.ts.
// jitterBufferTarget ist noch nicht in lib.dom.d.ts → schmaler Cast hier, nirgends sonst `any`.
import { clampJitterTarget, reZeroTarget, residualFromPlayout } from './av-sync-offset';

type TunableReceiver = RTCRtpReceiver & { jitterBufferTarget?: number | null };

/** Festen Offset (ms) auf den Video-Receiver legen (Sprecher: keine getStats-Audioquelle → fix). */
export function setVideoDelay(videoReceiver: RTCRtpReceiver, ms: number): void {
  (videoReceiver as TunableReceiver).jitterBufferTarget = clampJitterTarget(ms);
}

/** estimatedPlayoutTimestamp (Sekunden) eines Receivers aus getStats lesen; null wenn nicht verfügbar. */
async function playoutSec(receiver: RTCRtpReceiver): Promise<number | null> {
  try {
    const report = await receiver.getStats();
    for (const s of report.values()) {
      const stat = s as { type?: string; estimatedPlayoutTimestamp?: number };
      if (stat.type === 'inbound-rtp' && typeof stat.estimatedPlayoutTimestamp === 'number') {
        return stat.estimatedPlayoutTimestamp / 1000; // ms→s (NTP-ms in CR-Stats)
      }
    }
  } catch { /* getStats nicht verfügbar */ }
  return null;
}

/**
 * Gast-Re-Null: Restversatz zwischen Host-Audio- und Host-Video-Receiver messen und den
 * Video-jitterBufferTarget nachführen. Blip-frei (nur Pufferung). Liefert das neue Target
 * zurück (oder das alte, wenn keine Messung möglich war → Aufrufer fällt auf den Default zurück).
 */
export async function reZeroGuestVideo(
  audioReceiver: RTCRtpReceiver, videoReceiver: RTCRtpReceiver, currentTargetMs: number,
): Promise<number> {
  const [a, v] = await Promise.all([playoutSec(audioReceiver), playoutSec(videoReceiver)]);
  const residual = residualFromPlayout(a, v);
  if (residual === null) return currentTargetMs;
  const next = reZeroTarget(currentTargetMs, residual);
  setVideoDelay(videoReceiver, next);
  return next;
}
